import React from "react";
import { cn } from "@/lib/utils";
import markUrl from "@/assets/iq-mark.png";
import fullUrl from "@/assets/iq-logo-full.png";

// IQ Associates branding. `withWordmark` renders the full horizontal lockup
// (mark + "IQ | ASSOCIATES"); otherwise just the "iQ" mark. Both read cleanly
// on the dark theme (transparent backgrounds).
export function Logo({ size = 40, withWordmark = false, className, subtitle }) {
  if (withWordmark) {
    return (
      <div className={cn("flex flex-col", className)} data-testid="iq-logo">
        <img src={fullUrl} alt="IQ Associates" style={{ height: size * 1.35, width: "auto" }} className="object-contain" />
        {subtitle && <div className="mt-1 text-xs text-slate-400 font-mono">{subtitle}</div>}
      </div>
    );
  }
  return (
    <div className={cn("flex items-center", className)} data-testid="iq-logo">
      <img src={markUrl} alt="IQ Associates" style={{ width: size, height: size }} className="object-contain drop-shadow-[0_0_14px_rgba(0,153,255,0.45)]" />
    </div>
  );
}
